"use client"
import { Camera, Fuel, Key, FileText, ArrowLeft } from "lucide-react"
import Header from "./Header"
import { useLocation } from "react-router-dom"
import "./Css/ViewRepo.css"
import carkey from "../assets/carkey.jpg"
import GreyArrow from "../assets/greyLeftAr.png";
import {
  computeTodayDate,
  computeplussevendays,
  goBack,
  handleError,
} from "../CommonJquery/CommonJquery";
import { Button } from "@mui/material";
import { APL_LINK, server_post_data, get_repo_data } from "../ServiceConnection/serviceconnection"
import { useEffect ,useState} from "react"

import Loader from "./Loader.js";

const ViewRepo = () => {
  const location = useLocation()
  const { repoData: option } = location.state || {}
  const data = location.state.option;
  //console.log("option", data)
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false)
  const [RepoData, setRepoData] = useState([])
  const [CarImgPath, SetCarImgPath] = useState([])


  useEffect(() =>{
    master_data_get()
  },[] )

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", data.primary_id);
    await server_post_data(get_repo_data, fd)
      .then((Response) => {
        //console.log("Show_data", Response.data.message);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.repo_data.length > 0) {
            setRepoData(Response.data.message.repo_data[0]);
          }
          SetCarImgPath(APL_LINK + Response.data.message.image_link);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };


  

  // Use router data if available, otherwise use dummy data
  const repoData = RepoData 

  // If no data is provided, show a message
  // Only show no data message if explicitly passed null/undefined and not using dummy data
  if (!repoData && !RepoData) {
    return (
      <>
        <Header />
        {showLoaderAdmin && <Loader />}
        <div className="viewrepo-container">
          <div className="viewrepo-no-data">
            <h3>No repository data available</h3>
            <p>Please select a valid repository record to view details.</p>
          </div>
        </div>
      </>
    );
  }

  // Format date for display
  //   const formatDate = (dateString) => {
  //     const options = {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //     }
  //     return new Date(dateString).toLocaleDateString(undefined, options)
  //   }
  //console.log("repoData", repoData)
  const formatDate = (dateString) => {
    const date = new Date(dateString)

    const month = date.toLocaleString('default', { month: 'long' })
    const day = date.getDate().toString().padStart(2, '0')
    const year = date.getFullYear()

    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')

    return `${month} ${day} ${year}, ${hours}:${minutes}`
  }


  return (
    <>
      <Header />
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p>Vehicle Repository Details</p>

          <img src={GreyArrow} alt="Rapid Car Leasing" />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div>
      <div className="viewrepo-container">
        <div className="viewrepo-header">

          <div className="viewrepo-metadata">
            <span className="viewrepo-id">ID: {repoData.primary_id}</span>
            <span className="viewrepo-date">{repoData.entry_date ? formatDate(repoData.entry_date) : "N/A"}</span>
          </div>
        </div>

        <div className="viewrepo-content">
          {/* Vehicle Information Section */}
          <div className="viewrepo-section row">
            <div className="viewrepo-section-header">
              <h3>Vehicle Information</h3>
            </div>
            <div className="row">
              {/* First row of vehicle information */}
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">Vehicle Name:</span>
                  <span className="viewrepo-value">{repoData.car_data && repoData.car_data.length > 0 && repoData.car_data[0].car_name || "N/A"}</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">Vehicle Number:</span>
                  <span className="viewrepo-value">{repoData.car_data && repoData.car_data.length > 0 && repoData.car_data[0].car_tagline || "N/A"}</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">License Plate Number:</span>
                  <span className="viewrepo-value">{repoData.car_data && repoData.car_data.length > 0 && repoData.car_data[0].car_no || "N/A"}</span>
                </div>
              </div>

              {/* Second row of vehicle information */}
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">VIN Number:</span>
                  <span className="viewrepo-value">{repoData.car_data && repoData.car_data.length > 0 && repoData.car_data[0].vin || "N/A"}</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">Driver Name:</span>
                  <span className="viewrepo-value">{data.name || "N/A"}</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="viewrepo-info-item">
                  <span className="viewrepo-label">Booking ID:</span>
                  <span className="viewrepo-value">{repoData.booking_id || "N/A"}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Key Image and Gas Level in the same row */}
          <div className="row viewrepo-section" >
            {/* Key Image Section */}
            <div className="col-md-6">
              <div className="">
                <div className="viewrepo-section-header">
                  <Key className="viewrepo-icon" />
                  <h3>Key Image</h3>
                </div>
                <div className="viewrepo-key-image">
                  {repoData.repo_Key_image ? (
                    <div className="viewrepo-image-container">
                      <img
                        src={CarImgPath + repoData.repo_Key_image || "/placeholder.svg"}
                        alt="Vehicle Key"
                        className="viewrepo-image"
                      />
                    </div>
                  ) : (
                    <div className="viewrepo-no-image">
                      <p>No key image available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Gas Level Section */}
            <div className="col-md-6">
              <div className="">
                <div className="viewrepo-section-header">
                  <Fuel className="viewrepo-icon" />
                  <h3>Gas Level</h3>
                </div>
                <div className="viewrepo-gas-level">
                  <div className="viewrepo-gas-gauge">
                    <div className="viewrepo-gas-indicator">
                      <div className="viewrepo-gas-level-marks">
                        {[...Array(11)].map((_, i) => (
                          <div
                            key={i}
                            className={`viewrepo-gas-mark ${Number(repoData.repo_gas_level) >= i ? "active" : ""}`}
                          >
                            {i % 2 === 0 && <span className="viewrepo-gas-mark-label">{i}</span>}
                          </div>
                        ))}
                      </div>
                      <div className="viewrepo-gas-fill" style={{ width: `${(Number(repoData.repo_gas_level) / 10) * 100}%` }}></div>
                    </div>
                    <div className="viewrepo-gas-value">
                      <span className="viewrepo-gas-number">{repoData.repo_gas_level}</span>
                      <span className="viewrepo-gas-max">/10</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Car Images Section */}
          <div className="viewrepo-section row">
            <div className="viewrepo-section-header">
              <Camera className="viewrepo-icon" />
              <h3>Car Images (4 Corners)</h3>
            </div>
            <div className="viewrepo-car-images">
              <div className="row">
                {/* Front Left */}
                <div className="col-md-6 col-lg-3 mb-3">
                  <div className="viewrepo-image-card">
                    <h5 className="viewrepo-image-title">Driver Left</h5>
                    {repoData.repo_front_left_car_images ? (
                      <img
                        src={CarImgPath + repoData.repo_front_left_car_images || "/placeholder.svg"}
                        alt="Front Left View"
                        className="viewrepo-car-image"
                      />
                    ) : (
                      <div className="viewrepo-no-image">
                        <p>No image</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Front Right */}
                <div className="col-md-6 col-lg-3 mb-3">
                  <div className="viewrepo-image-card">
                    <h5 className="viewrepo-image-title">Driver Right</h5>
                    {repoData.repo_front_right_car_images ? (
                      <img
                        src={CarImgPath + repoData.repo_front_right_car_images || "/placeholder.svg"}
                        alt="Front Right View"
                        className="viewrepo-car-image"
                      />
                    ) : (
                      <div className="viewrepo-no-image">
                        <p>No image</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Back Left */}
                <div className="col-md-6 col-lg-3 mb-3">
                  <div className="viewrepo-image-card">
                    <h5 className="viewrepo-image-title">Passanger Left</h5>
                    {repoData.repo_back_left_car_images ? (
                      <img
                        src={CarImgPath + repoData.repo_back_left_car_images || "/placeholder.svg"}
                        alt="Back Left View"
                        className="viewrepo-car-image"
                      />
                    ) : (
                      <div className="viewrepo-no-image">
                        <p>No image</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Back Right */}
                <div className="col-md-6 col-lg-3 mb-3">
                  <div className="viewrepo-image-card">
                    <h5 className="viewrepo-image-title">Passanger Right</h5>
                    {repoData.repo_back_right_car_images ? (
                      <img
                        src={CarImgPath + repoData.repo_back_right_car_images || "/placeholder.svg"}
                        alt="Back Right View"
                        className="viewrepo-car-image"
                      />
                    ) : (
                      <div className="viewrepo-no-image">
                        <p>No image</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Notes Section */}
          <div className="viewrepo-section row">
            <div className="viewrepo-section-header">
              <FileText className="viewrepo-icon" />
              <h3>Additional Notes</h3>
            </div>
            <div className="viewrepo-notes">
              {repoData.repo_notes ? (
                <p className="viewrepo-notes-content">{repoData.repo_notes}</p>
              ) : (
                <p className="viewrepo-no-notes">No additional notes provided</p>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          {/* <div className="viewrepo-actions">
            <button className="viewrepo-button viewrepo-button-back" onClick={() => window.history.back()}>
              Back to List
            </button>
            <button className="viewrepo-button viewrepo-button-print" onClick={() => window.print()}>
              Print Report
            </button>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default ViewRepo
